import CategoriesTable from './lib/table';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import PrimaryButton from 'components/form/buttons/primaryButton';

import PageTitle from 'components/pageTitle';

import * as S from './styles';

const PlusIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round">
    <path d="M12 5v14M5 12h14" />
  </svg>
);

export default function CategoriesPage() {
  const { ticketCategory } = useTypedSelector((state) => state.Tickets);

  return (
    <S.Container>
      <PageTitle title="Ticket Categories" />
      <S.Head>
        <PrimaryButton link="/panel/ticket/categories/create">
          <PlusIcon />
          New category
        </PrimaryButton>
      </S.Head>
      <CategoriesTable data={ticketCategory.data} loading={ticketCategory.loading} />
    </S.Container>
  );
}
